module.exports = __webpack_public_path__ + "static/media/safari-logo.77e23919.png";